import axios from "axios";
import { Toast } from "vant";
import router from "../router/index";
import api from "../api";
import store from "../store";
import { getToken, setToken, setOpenid, getOpenid, removeToken } from "./auth";
const duration = 1.5 * 1000;
// create an axios instance
const service = axios.create({
    baseURL: process.env.BASE_URL, // url = base url + request url
    // withCredentials: true, // send cookies when cross-domain requests
    timeout: 50000 // request timeout
});

// request interceptor
service.interceptors.request.use(
    config => {
        // do something before request is sent
        // console.log('开始请求啦≧◔◡◔≦', config);
        /**
         * 如果请求中存在noToast参数将不出现loading弹窗
         */
        if (!config.noToast) {
            Toast.loading({
                forbidClick: true,
                duration: 0,
                className: "custom-loading"
            });
        }
        config.headers["Content-Type"] = "application/json;charset=utf-8";
        var token = getToken();
        var appid = sessionStorage.getItem("appid");
        if (token) {
            config.headers["Authorization"] = `Bearer ${token}`;
            // config.headers['token'] =token
        }
        if (appid) {
            config.headers.appId = appid;
        }
        return config;
    },
    error => {
        // do something with request error
        // console.log(error, 'err') // for debug
        return Promise.reject(error);
    }
);

// response interceptor
service.interceptors.response.use(
    /**
     * If you want to get http information such as headers or status
     * Please return  response => response
     */

    /**
     * Determine the request status by custom code
     * Here is just an example
     * You can also judge the status by HTTP Status Code
     */
    response => {
        const res = response.data;
        // console.log('请求结束啦≧◠◡◠≦');
        if (response.config.data) {
            if (typeof response.config.data === "string") {
                let data = JSON.parse(response.config.data);
                if (!data.noToast) {
                    Toast.clear();
                }
            } else {
                Toast.clear();
            }
        }
        if (response.config.params) {
            if (!response.config.params.noToast) {
                Toast.clear();
            }
        }

        // if(response.config.data){
        //   let data = JSON.parse(response.config.data)
        //   if(!data.noToast){
        //     Toast.clear();
        //   }
        // }
        // if(response.config.params){
        //   if(!response.config.params.noToast){
        //     Toast.clear();
        //   }
        // }
        // if the custom code is not 0, it is judged as an error.
        if (res.code !== 0) {
            if (
                res.code === 200010 ||
                res.code === 1001 ||
                res.code === 1002 ||
                res.code === 200011
            ) {
                let url = window.location.hash.split("#")[1];
                if (url.indexOf("login") > -1) {
                    url = "/my";
                }
                sessionStorage.setItem("backUrl", url);
                // 患者不存在 去登录/注册
                store.dispatch("user/loginStatus", res);
                return Promise.reject(res);
            }
            // 针对限制就诊人接口
            if (res.code === 999) {
                return Promise.reject(res);
            }
            /**
             * 如果还没有登录
             */
            Toast({
                message: res.msg,
                duration: duration
            });
            return Promise.reject(res);
        } else {
            return res;
        }
    },
    error => {
        Toast.fail({
            message: "网络错误，请稍后重试",
            duration: duration
        });
        return Promise.reject(error);
    }
);
/**
 *
 * @param {String} name  key名
 * 获取url中的参数
 */
var getQueryString = function(name) {
    if (!name || name == "") {
        return false;
    }
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    var hashU = window.location.hash.split("?")[1];
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return unescape(r[2]);
    return false;
};

var getQueryStringHash = function(name) {
    if (!name || name == "") {
        return false;
    }
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    var hashU = window.location.hash.split("?")[1];
    var r = hashU ? hashU.match(reg) : "";
    if (r != null) return unescape(r[2]);
    return false;
};

/**
 *
 * @param {Object} params
 * 全局封装请求
 */
export default function fetch(params) {
    return new Promise((resolve, reject) => {
        /**
         * 获取url中的code和state
         * code：用于获取openid
         * state：用于判断是从哪个公众号进来的,
         * code:999  当token过期时根据openid获取最新token然后再重新调用报错接口
         */
        let code = getQueryString("code");
        let state = getQueryString("state");
        let doctorToken = getQueryStringHash("doctorToken");
        let sourceDoctor = getQueryStringHash("source");
        // console.log('fdasfsd',sourceDoctor, doctorToken)
        let phone = "";
        if (state) {
            let appidArr = state.split("_");
            sessionStorage.setItem("appid", appidArr[0]);
            if (appidArr.length > 1) {
                if (appidArr[1] == "null") {
                    phone = "";
                } else {
                    phone = appidArr[1];
                }
            }
        }
        // 医生端查看h5页面，需要调取医生端接口，保存医生端的token
        if (doctorToken != "undefined" && doctorToken) {
            setToken(doctorToken);
        }

        let openid = getOpenid();
        /**
         * 判断有没有token
         */
        if (getToken()) {
            if (sourceDoctor != "undefined" && doctorToken) {
                sendServer();
                return;
            }
            // 有获取用户详情并存储到store中
            if (!store.getters.userInfo.id) {
                service
                    .request({
                        url: api.user.getDetailUrl,
                        method: "post",
                        data: {}
                    })
                    .then(({ data }) => {
                        store.commit("user/setUserInfo", data);
                        store.dispatch("user/getNotSignAgreement");
                        // 初始化
                        if (!data.phone) {
                            store.dispatch("user/loginStatus", { code: "-1" }); //绑定
                        } else {
                            if (phone && data.phone != phone) {
                                store.dispatch("user/loginStatus", {
                                    code: "-2",
                                    phone
                                }); //切换账号
                                Toast.clear();
                            } else {
                                // 查看协议状态
                                sendServer();
                            }
                        }
                    });
            } else {
                sendServer();
            }
        } else {
            // console.log('openid',code,openid,router.app._route.name)
            // if (code && !openid) {
            if (code&&code!=localStorage.getItem('code')) {
                if (router.app._route.name == "PayHelpPay") {
                    sendServer();
                } else {
                    service
                        .request({
                            url: api.user.loginUrl,
                            method: "post",
                            data: {
                                type: "auth_code",
                                namespace: sessionStorage.getItem("appid"),
                                wechatCode: code
                            }
                        })
                        .then(({ data }) => {

                            /**
                             * 查看返回的数据
                             */
                            store.commit("user/setUserInfo", data.baseInfo);
                            setOpenid(data.openid);
                            setToken(data.accessToken);
                            // 初始化
                            if (!data.baseInfo.phone) {
                                store.dispatch("user/loginStatus", {
                                    code: "-1"
                                }); //绑定
                            } else {
                                if (phone && data.baseInfo.phone != phone) {
                                    store.dispatch("user/loginStatus", {
                                        code: "-2",
                                        phone
                                    }); //切换账号
                                    Toast.clear();
                                } else {
                                    store.dispatch("user/getNotSignAgreement");
                                    sendServer();
                                }
                            }
                        });
                }
            } else {
                sendServer();
            }
        }
        if (code&&code!=localStorage.getItem('code')) {
            localStorage.setItem('code',code)
        }

        function sendServer() {
            service
                .request(params)
                .then(newRes => {
                    resolve(newRes);
                })
                .catch(err => {
                    reject(err);
                });
        }
    });
}



// WEBPACK FOOTER //
// ./src/utils/request.js